import React from 'react';
import { Button } from '@brighterion/br-ui';
import { useHistory, useLocation } from 'react-router-dom';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { useTranslation } from 'react-i18next';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';
import styles from './NewReportBtn.css';

type Props = {
    reportType: ReportType;
};

const NewReportButton = ({ reportType }: Props) => {
    const history = useHistory();
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const handleClickNewMerchant = () => {
        switch (reportType) {
            case 'merchantsummary': {
                trackEvent({
                    eventType: EventTypes.track,
                    eventName: EventNames.click,
                    payload: {
                        clickIdentifier: 'New Merchant Summary Report - Generate New Report',
                        text: 'Generate New Merchant Summary Report'
                    }
                });
                break;
            }
            case 'performance': {
                trackEvent({
                    eventType: EventTypes.track,
                    eventName: EventNames.click,
                    payload: {
                        clickIdentifier: 'New Rule Performance Report - Generate New Report',
                        text: 'Generate New Rule Performance Report'
                    }
                });
                break;
            }
            default: {
                break;
            }
        }
        history.push(`${pathname}/new-${reportType}-report`);
    };

    return (
        <div className={styles.hiddenRelativeContainer}>
            <div className={styles.absoluteContainer}>
                <span className={styles.newReportBtn}>
                    <Button
                        variant='secondary'
                        size='small'
                        onClick={handleOnClickEvent(handleClickNewMerchant)}
                        onKeyDown={handleKeyEvent(handleClickNewMerchant)}
                    >
                        {t('New Report')}
                    </Button>
                </span>
            </div>
        </div>
    );
};

export default NewReportButton;
